import { Box, Button, Typography } from '@mui/material';
import RenewalContractSummary from '~/pages/contract/renewal/journey/components/RenewalContractSummary';
import { formatRenewalCurrency } from '~/pages/contract/renewal/journey/renewalReview';
import type { CardChangeContract } from '~/services/modules/cardChange';
import { CARD_CHANGE_APP_IDS } from '../cardChangeAppIds';

type Props = {
  contract: CardChangeContract;
  onStart: () => void;
  onSupport: () => void;
};

/**
 * Primeira tela da troca de cartão 2026: resumo do contrato (mesmo card da identificação da renovação,
 * Figma 2079:6265, sem a parte do código) e «Alterar dados do cartão de crédito», que abre o formulário.
 * Substitui o «Configuração da assinatura» do legado (`ContractInfo`).
 */
export default function CardChangeSummaryStep({ contract, onStart, onSupport }: Props) {
  return (
    <Box
      data-app-id={CARD_CHANGE_APP_IDS.stepSummary}
      sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}
    >
      <Typography component="h1" sx={{ textAlign: 'center', width: '100%' }} variant="h5">
        Configuração da assinatura
      </Typography>

      <RenewalContractSummary
        appId={CARD_CHANGE_APP_IDS.contractSummary}
        contract={contract}
        extraFields={[{ label: 'Tipo', value: contract.insured_item?.equipment_type }]}
      />

      <Box
        data-app-id={`${CARD_CHANGE_APP_IDS.stepSummary}-total`}
        sx={{ alignItems: 'baseline', display: 'flex', flexWrap: 'wrap', gap: '8px 16px', justifyContent: 'center' }}
      >
        <Typography sx={{ color: 'text.primary' }} variant="subtitle1">
          Valor da assinatura
        </Typography>
        <Typography sx={{ color: 'primary.main', fontWeight: 600 }} variant="subtitle1">
          {formatRenewalCurrency(contract.total)}
        </Typography>
      </Box>

      <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
        <Button
          data-app-id={CARD_CHANGE_APP_IDS.startChange}
          fullWidth
          onClick={onStart}
          size="large"
          variant="contained"
        >
          Alterar dados do cartão de crédito
        </Button>

        <Box
          sx={{
            alignItems: 'center',
            columnGap: '24px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <Typography sx={{ color: 'text.secondary' }} variant="body1">
            Algum dado não confere?
          </Typography>
          <Button
            data-app-id={CARD_CHANGE_APP_IDS.summarySupport}
            onClick={onSupport}
            sx={(theme) => ({ color: theme.customColors.tertiaryMain })}
            variant="text"
          >
            Fale com o atendimento
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
